import { ConnectWithGmailForm } from '@/pages/settings/profile/components/ConnectWithGmailForm';
import GoogleIcon from '@/icons/Google';
import { selectMeForUpdate } from '@/store/me';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@chakra-ui/react';
export const GmailButton = ({
  variant = 'google-login',
  text = 'Connect your account',
}) => {
  const { user } = useSelector(selectMeForUpdate);
  const dispatch = useDispatch();
  return (
    <ConnectWithGmailForm user={user} dispatch={dispatch}>
      <Button
        type="submit"
        variant={variant}
        leftIcon={<GoogleIcon />}
        className="gmail-button"
      >
        {text}
      </Button>
    </ConnectWithGmailForm>
  );
};
